import type { AllRouteEndpoints } from "../routeTypes";

export const conversationalToolDefinitionCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/conversational/tool_definitions",
];
